import {lazy} from 'react'
import {Route, Routes} from 'react-router-dom'

export enum BillingRouterEnum {
    /*Rotas para Conta-Corrente*/
    InvoiceClinic = '/financeiro/faturamento/estabelecimento',
    InvoiceClinicDetail = '/financeiro/faturamento/:id/estabelecimento',
    InvoiceDoctor = '/financeiro/faturamento/profissional',
    InvoiceDoctorDetail = '/financeiro/faturamento/:id/profissional/:doctorId',
}

const ApprovedNotes = lazy(() => import('../../pages/billing/fiscalNotes/ApprovedNotes'))
const PendingNotes = lazy(() => import('../../pages/billing/fiscalNotes/PendingNotes'))

/*Rotas para Conta-Corrente*/
const InvoiceClinic = lazy(
    () => import('../../pages/billing/invoices/clinic/DatatableClinicInvoice')
)
const InvoiceClinicDetail = lazy(
    () => import('../../pages/billing/invoices/clinic/ShowClinicInvoice')
)
const InvoiceDoctor = lazy(
    () => import('../../pages/billing/invoices/doctor/DatatableDoctorInvoice')
)
const InvoiceDoctorDetail = lazy(
    () => import('../../pages/billing/invoices/doctor/ShowDoctorInvoice')
)

export default function BillingRouter() {
    return (
        <Routes>
            {/* Paths relativos ao prefixo /financeiro consumido em PrivateRoutes */}
            <Route path='notas-fiscais/aprovadas' element={<ApprovedNotes />} />
            <Route path='notas-fiscais/pendentes' element={<PendingNotes />} />

            {/*Rotas para Conta-Corrente*/}
            <Route path='faturamento/:id/estabelecimento' element={<InvoiceClinicDetail />} />
            <Route path='faturamento/estabelecimento' element={<InvoiceClinic />} />
            <Route path='faturamento/profissional' element={<InvoiceDoctor />} />
            <Route
                path='faturamento/:id/profissional/:doctorId'
                element={<InvoiceDoctorDetail />}
            />
        </Routes>
    )
}
